import React from "react"
import { Button, Form, Modal } from "react-bootstrap"
import CurrencyInput from "react-currency-input"

import POSContext from "../../context"

import MainSection from "./MainSection"
import CancelSaleButton from "./CancelSale"
import ClientButton from "./SaleClient"
import SaleCPF from "./SaleCPF"
import GoToPayments from "./GoToPayments"

export default class FooterActionsPOS extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modalCancelSale: false,
            modalSelectClient: false,
            modaSalelDiscount: false
        }
        this._openModalDiscount = this._openModalDiscount.bind(this)
        this._closeModalDiscount = this._closeModalDiscount.bind(this)
        this._onSetDiscount = this._onSetDiscount.bind(this)
        this._onEnterPressModalDiscount = this._onEnterPressModalDiscount.bind(this)
    }

    _openModalDiscount() {
        this.setState({ ...this, modaSalelDiscount: true })
        setTimeout(() => {
            try {
                document.getElementById("pos-input-discout-value").focus()
            } catch (error) { }
        }, 100)
    }
    _onEnterPressModalDiscount(e) {
        if (e.key === "Enter") {
            this._onSetDiscount()
        }
    }
    _closeModalDiscount() {
        this.setState({ ...this, modaSalelDiscount: false })
    }
    _onSetDiscount() {
        this.props.onSetDiscount()
        this.setState({ ...this, modaSalelDiscount: false })
    }

    render() {
        return <POSContext.Consumer>
            {
                sale => {
                    let clientName = ""
                    const hasClient = !!sale.client_name
                    const hasCPF = !!sale.cpf_cnpj

                    return <MainSection>
                        <CancelSaleButton
                            className="col-6 col-sm-4 col-md-2"
                        />

                        {!hasCPF && (
                            <ClientButton
                                onSetClient={this.props.onSetClient}
                                removeClient={this.props.removeClient}
                                className={`col-${hasClient ? "12" : "6"} col-sm-${hasClient ? "8" : "4"} col-md-${hasClient ? "5" : "2"}`}
                            />
                        )}

                        {!hasClient && (
                            <SaleCPF
                                onSetCPF={this.props.onSetCPF}
                                removeCPF={this.props.removeCPF}
                                className={`col-${hasCPF ? "12" : "6"} col-sm-${hasCPF ? "8" : "4"} col-md-${hasCPF ? "5" : "3"}`}
                            />
                        )}

                        <div className="col-6 col-sm-4 col-md-2">
                            <Button
                                disabled={!sale.items.length}
                                onClick={this._openModalDiscount}
                                className="w-100 dim py-2" variant="info">
                                Desconto
                            </Button>
                        </div>
                        <GoToPayments
                            className="col-12 col-sm-4 col-md-3" />


                        <Modal show={this.state.modaSalelDiscount} onHide={this._closeModalDiscount}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    Desconto
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>
                                    Escolha o tipo de desconto
                                </p>
                                <div className="d-flex justify-content-between my-3">
                                    <div className="d-flex flex-row">
                                        <Form.Check
                                            onChange={this.props.onSetDiscountType}
                                            type="radio"
                                            name="cash"
                                            checked={sale.discount_type === "cash"}
                                            label="desconto em R$" />
                                    </div>
                                    <div className="d-flex flex-row">
                                        <Form.Check
                                            onChange={this.props.onSetDiscountType}
                                            type="radio"
                                            name="percent"
                                            checked={sale.discount_type === "percent"}
                                            label="desconto em %" />
                                    </div>
                                </div>
                                <p>
                                    Valor do desconto
                                </p>
                                <CurrencyInput
                                    decimalSeparator=","
                                    thousandSeparator="."
                                    precision="2"
                                    onKeyDown={this._onEnterPressModalDiscount}
                                    id="pos-input-discout-value"
                                    value={sale.discount_value_input}
                                    prefix={sale.discount_type === "percent" ? "% " : "R$ "}
                                    onChange={this.props.onChangeInputDiscount}
                                    className="form-control" />
                            </Modal.Body>
                            <Modal.Footer>
                                <Button onClick={this._onSetDiscount}>
                                    Salvar desconto
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </MainSection>
                }

            }
        </POSContext.Consumer>
    }
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/FooterActionsPOS/index.jsx